<template>
  <v-container style="max-width:100vw;" v-if="currentUser">
    <!-- Drawer de filtros -->
    <v-navigation-drawer
      right app
      v-model="filtersOpen"
      style="top:0px; max-height:100vh!important;"
      :clipped="$vuetify.breakpoint.lgAndUp"
    >
      <influencer-files-filter @apply="onFiltersApplied"/>
    </v-navigation-drawer>

    <v-data-table
      class="elevation-0 px-6 py-4"
      :headers="headers"
      :items="rows"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      height="600"
      fixed-header
      :multi-sort="true"
      :footer-props="{ 'items-per-page-options': [15, 30, 50, 100, total>999?999:total] }"
    >
      <template v-slot:top>
        <v-toolbar flat class="mb-2">
          <v-toolbar-title>Documentos de Influencers</v-toolbar-title>

          <v-btn icon @click="toggleFilters">
            <template v-if="activeFiltersCount>0">
              <v-badge overlap color="primary">
                <template v-slot:badge>{{ activeFiltersCount }}</template>
                <v-icon>mdi-filter</v-icon>
              </v-badge>
            </template>
            <template v-else>
              <v-icon>mdi-filter</v-icon>
            </template>
          </v-btn>

        </v-toolbar>
      </template>

      <template v-slot:[`item.url`]="{ item }">
        <v-btn v-if="item.url" icon :href="'https://peach.blitzhub.mx/files/' + item.url" target="_blank" title="Abrir URL">
          <v-icon small>mdi-file</v-icon>
        </v-btn>
      </template>
      
      <template v-slot:[`item.description`]="{ item }">
        <v-tooltip v-if="item.description!=null && item.description!=''" left max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small v-bind="attrs" v-on="on">
              mdi-comment
            </v-icon>
          </template>
          {{item.description}}
        </v-tooltip>
      </template>

      <template v-slot:[`item.influencer`]="{ item }">
        <!-- Mostramos lo que venga; si el back manda objeto, tomamos un nombre amigable -->
        {{ humanInfluencer(item) }}
      </template>

      <template v-slot:[`item.additional_data`]="{ item }">
        <span class="grey--text text--darken-1">
          {{ shortJSON(item.additional_data) }}
        </span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon small @click="openEdit(item)" title="Editar">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon small @click="confirmDelete(item)" title="Eliminar">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:no-data>
        No existen registros para los criterios seleccionados.
      </template>
    </v-data-table>

    <!-- Crear -->
    <v-dialog v-model="createOpen" max-width="700px">
      <influencer-files-create v-if="createOpen" @close="createOpen=false" @saved="refreshAfterSave"/>
    </v-dialog>

    <!-- Editar -->
    <v-dialog v-model="editOpen" max-width="700px">
      <influencer-files-edit v-if="editOpen" :item="selected" @close="closeEdit" @saved="refreshAfterSave"/>
    </v-dialog>

    <!-- Confirmación de borrado -->
    <v-bottom-sheet v-model="deleteSheet" inset>
      <v-sheet class="text-center" height="160px">
        <div class="pt-6">¿Seguro que deseas borrar este registro?</div>
        <v-btn class="mt-4" text color="error" @click="doDelete">Eliminar</v-btn>
        <v-btn class="mt-4" text color="grey" @click="deleteSheet=false">Cancelar</v-btn>
      </v-sheet>
    </v-bottom-sheet>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>

    <v-btn bottom color="#f48a5a" dark fab fixed right @click="openCreate()">
        <v-icon color="white">  mdi-plus </v-icon>
    </v-btn> 
  </v-container>
</template>

<script>
import axios from 'axios'
import InfluencerFilesFilter from './filter.vue'
import InfluencerFilesCreate from './create.vue'
import InfluencerFilesEdit from './edit.vue'

export default {
  name: 'InfluencerFilesContainer',
  components: {
    'influencer-files-filter': InfluencerFilesFilter,
    'influencer-files-create': InfluencerFilesCreate,
    'influencer-files-edit': InfluencerFilesEdit,
  },
  data: () => ({
    filtersOpen: false,
    createOpen: false,
    editOpen: false,
    deleteSheet: false,

    selected: null,
    deletingId: null,

    rows: [],
    total: 0,
    loading: false,
    options: {
      page: 1,
      itemsPerPage: 15,
      sortBy: ['created_at'],
      sortDesc: [true],
    },
    headers: [
      { text: 'Influencer', value: 'influencer' },
      { text: 'Título', value: 'title' },
      { text: 'Descripción', value: 'description', sortable: false },
      { text: 'Archivo', value: 'url', sortable: false },
      { text: 'Acciones', value: 'actions', sortable: false, width: 120 },
    ],
    snackbar: { show: false, message: null, color: null },
  }),
  computed: {
    currentUser () {
      return (this.$store.state.currentUser && this.$store.state.currentUser.user) || null
    },
    activeFiltersCount () {
      const raw = localStorage.getItem('filtersInfluencerFilesLength')
      const n = raw ? parseInt(raw, 10) : 0
      return Number.isNaN(n) ? 0 : n
    },
  },
  watch: {
    options: {
      deep: true,
      handler () { this.fetchRows() }
    },
    currentUser () { this.fetchRows() }
  },
  mounted () {
    this.fetchRows()
  },
  methods: {
    toggleFilters () { this.filtersOpen = !this.filtersOpen },
    onFiltersApplied () { this.fetchRows() },
    openCreate () { this.createOpen = true },
    openEdit (item) { this.selected = item; this.editOpen = true },
    closeEdit () { this.editOpen = false; this.selected = null },
    confirmDelete (item) {
      console.log(item)
      this.deletingId = item.id
      this.deleteSheet = true
    },
    async doDelete () {
      try {
        await axios.delete(process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer_files/' + this.deletingId)
        this.snackbar = { show: true, color: 'success', message: 'Eliminado correctamente' }
        this.fetchRows()
      } catch (e) {
        this.snackbar = { show: true, color: 'error', message: 'No se pudo eliminar' }
      } finally {
        this.deleteSheet = false
        this.deletingId = null
      }
    },
    refreshAfterSave () {
      this.createOpen = false
      this.editOpen = false
      this.selected = null
      this.fetchRows()
    },
    buildSortParam (sortBy, sortDesc) {
      // Permite ordenar por id, title, type, influencer_id (ajusta si tu backend acepta más)
      const allowed = { id:1, title:1, type:1, influencer_id:1 }
      if (!Array.isArray(sortBy) || !sortBy.length) return ''
      const parts = []
      for (let i = 0; i < sortBy.length; i++) {
        const key = sortBy[i]
        if (!allowed[key]) continue
        const desc = Array.isArray(sortDesc) && sortDesc[i] === true
        parts.push((desc ? '-' : '') + key)
      }
      return parts.length ? ('sort=' + parts.join(',') + '&') : ''
    },
    async fetchRows () {
      this.loading = true
      try {
        const page = this.options.page
        const itemsPerPage = this.options.itemsPerPage
        const sortQS = this.buildSortParam(this.options.sortBy, this.options.sortDesc)
        const savedFilter = localStorage.getItem('filtersInfluencerFiles')
        const filterQS = savedFilter ? JSON.parse(savedFilter) : ''
        const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer_files?'
        const joiner = (sortQS || filterQS) ? '&' : ''
        const url = base + (sortQS || '') + (filterQS || '') + joiner + 'page=' + page + '&itemsPerPage=' + itemsPerPage

        const res = await axios.get(url)
        const list = (res && res.data && res.data.data) ? res.data.data : []
        const total = (res && res.data && res.data.meta && res.data.meta.total) ? res.data.meta.total : list.length

        this.rows = this.mapRows(list)
        this.total = total
      } catch (e) {
        this.rows = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },
    mapRows (list) {
      return list.map(function (r) {
        return {
          id: r.id,
          influencer_id: r.influencer_id,
          influencer: r.influencer || null, // si el back manda objeto, lo pasamos
          title: r.title || '',
          description: r.description || '',
          type: r.type || '',
          url: r.url || '',
          additional_data: r.additional_data || ''
        }
      })
    },
    humanInfluencer (item) {
      // si el back trae r.influencer, usamos algo legible
      const inf = item.influencer
      if (inf) {
        // intenta social_networks.instagram, name, etc
        if (inf.social_networks && inf.social_networks.instagram) return inf.social_networks.instagram
        if (inf.name) return inf.name
      }
      return item.influencer_id ? ('#' + item.influencer_id) : ''
    },
    shortJSON (val) {
      if (!val) return ''
      try {
        const s = typeof val === 'string' ? val : JSON.stringify(val)
        return s.length > 80 ? (s.slice(0, 77) + '...') : s
      } catch (e) {
        return String(val).slice(0, 80)
      }
    },
  }
}
</script>

<style>
.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  padding: 0 5px !important;
  font-size:10px!important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td{ font-size:13px!important; }
</style>
